import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Enforces admin-managed 301 redirects (stored in the `redirects` collection).
 * On every navigation it asks the backend whether the current path has a redirect
 * and, if so, sends the browser to the target URL.
 *
 * NOTE: This is a client-side redirect (returns 200 then navigates), not a true
 * HTTP 301. For full SEO link-equity on the production domain, configure the same
 * rules as Cloudflare Bulk Redirects (the domain is behind Cloudflare).
 */
export const RedirectHandler = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let active = true;

    // Normalize: lowercase + strip trailing slash (from_path is stored lowercased)
    const normalized = (pathname.replace(/\/+$/, '') || '/').toLowerCase();
    if (normalized === '/') return; // never redirect the homepage

    const rest = normalized.replace(/^\//, '');

    axios
      .get(`${API}/redirects/check/${rest}`)
      .then((res) => {
        const target = res.data?.to_path;
        if (active && target) {
          window.location.replace(target);
        }
      })
      .catch(() => {});

    return () => {
      active = false;
    };
  }, [pathname]);

  return null;
};

export default RedirectHandler;
